<script lang="ts">
    import ReviewsListInfoEntity from "@apps/reviews/entities/ReviewsListInfoEntity";
    import Text from "@components_v2/Typography/Text.svelte";

    import ReviewsTotalRateBar from "./ReviewsTotalRateBar.svelte";

    export let averageReviewsRating = 0;
    export let ratesInfo: ReviewsListInfoEntity["ratesInfo"] = [];
    export let reviewsCount = 0;
</script>

<div class="gw-rv-total-rate">
    <div class="gw-rv-total-rate__rating">
        <Text variant="heading-3xl" tone="inherit">
            {averageReviewsRating}
        </Text>
    </div>

    <ul class="gw-rv-total-rate__bars gw-list-reset-default-styles">
        {#each [...ratesInfo].reverse() as review}
            <ReviewsTotalRateBar
                {reviewsCount}
                reviewCount={review.countReview}
                rate={review.rating}
            />
        {/each}
    </ul>
</div>

<style lang="postcss">
    .gw-rv-total-rate {
        display: flex;
        align-items: center;
        min-width: 224px;

        &__rating {
            width: var(--gw-width-2000);
            text-align: center;
        }

        &__bars {
            display: flex;
            flex-direction: column;
            flex: 1;
        }
    }
</style>
